<template>
  <div class="animate-panel"  data-child="hpanel" data-effect="fadeInDown">
    <div class="hpanel no-margins" >
      <template v-if="authors.length !== 0">
        <div class="panel-body no-padding ">
          <table style="width: 100%;margin-top: 5px">

            <tr style="height: 25px">
              <th class="visible-md visible-lg visible-xl col-md-2 col-lg-2 col-xl-1 text-center">

                <div class="btn-group">
                  <button type="button" class="btn btn-info btn-outline btn-xs" style="padding-left: 10px;padding-right: 0;" @click="allChecked = !allChecked">
                    <div class="checkbox checkbox-info" style="margin: 2px 0 0 0;">
                      <input type="checkbox" :checked="allChecked">
                      <label></label>
                    </div>
                  </button>
                  <button type="button" class="btn btn-info btn-outline btn-xs dropdown-toggle dropdown-toggle-split" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style="padding-top: 4px;padding-bottom: 4px;">
                    <i class="fa fa-caret-down"></i>
                  </button>
                  <ul class="dropdown-menu pull-right" aria-labelledby="dropdownMenu1" style="float: right" >
                    <li v-if="allChecked === false"><a role="button" @click="allChecked = true"><i class="far fa-check-square text-success"></i> Selected All</a></li>
                    <li v-if="allChecked === true"><a role="button" @click="allChecked = false"><i class="far fa-square-o text-danger"></i> Unselected All</a></li>
                    <li><a role="button" @click="addAllSelected"><i class="fa fa-plus text-success"></i> Add Selected</a></li>
                    <li><a role="button" @click="deleteAllSelected"><i class="fa fa-trash text-danger"></i> Delete Selected</a></li>
                    <!--                      <li><a role="button" ><i class="fa fa-copy text-warning"></i> Copy Selected</a></li>-->
                  </ul>
                </div>
              </th>
              <th class="col-xs-4 col-md-3 col-lg-1 col-xl-2"><span role="button" @click="changeSort('expert')">Expert <i style="padding-left: 15px" class="fa fa-sort"></i></span></th>
              <th class="col-xs-5 col-md-5 col-lg-3 col-xl-3">
                <table class="table" style="width: 100%;">
                  <td class="col-xs-5 col-md-5 col-lg-5 text-center" style="vertical-align: middle">
                    <span role="button" @click="changeSort('country')">Country <i style="padding-left: 15px" class="fa fa-sort"></i></span>
                  </td>
                  <td class="col-xs-7 col-md-7 col-lg-7" style="vertical-align: middle">
                    <span role="button" @click="changeSort('affiliation')">Affiliation <i style="padding-left: 15px" class="fa fa-sort"></i></span>
                  </td>
                </table>
              </th>
              <th class="col-lg-4 col-xl-4 visible-lg visible-xl"><span>Top document</span></th>
              <th class="col-md-1 col-xs-1 visible-lg visible-xl"></th>
              <th class="col-xs-2 col-md-2 col-lg-1 col-xl-1 text-center"><span>Action</span></th>
            </tr>

          </table>
          <div v-if="authors.length !== 0" >
            <div v-for="(author, key) in authors" v-if="author && key < context.nbItemsDisplay" :key="key + '-' + author.authorID" class="clearfix ">
              <div class="col-xs-12 top-document" data-toggle="collapse" :data-target="'#collapse-'+ author.authorID" aria-expanded="false" :aria-controls="'collapse-'+ author.authorID">
                <author-top v-model="authors[key]" :context="context" :key="key + '-' + author.authorID + '-' + author.checked + '-' + author.followSearchId" @authorChecked="authorChecked"/>
                <div style="bottom: -9px;position: absolute;width: 100%">
                  <span style="margin-left: 49%;background-color: white;">
                    <button style="border-radius: 50px;font-size: 0.6rem;" class="btn btn-info btn-xs">
                    <i class="fa fa-chevron-down"></i>
                    </button>
                  </span>
                </div>

              </div>
              <div class="col-xs-12 collapse" :id="'collapse-'+ author.authorID" style="padding: 20px" >
                <document-author v-model="authors[key].docs" :author="author"
                                 :pubDateSelected="context.pubDateSelected" :context="context"/>
              </div>
            </div>
            <div class="text-center" style="padding: 25px" v-if="authors.length > context.nbItemsDisplay">
              <button class="btn btn-primary btn-xs" :class="authors.length > context.nbItemsDisplay ? '' : 'disabled'" @click="context.displayMore">Display more</button>
              <button class="btn btn-primary btn-xs" :class="authors.length > context.nbItemsDisplay ? '' : 'disabled'" @click="context.displayAll">Display all</button>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import AuthorTop from './../documents/AuthorTop'
import DocumentAuthor from '../documents/DocumentAuthor'

export default {
  components: {
    DocumentAuthor,
    AuthorTop
  },
  props: ['context', 'value', 'listType', 'changeSort'],
  name: 'ListAuthorsSimilar',
  watch: {
    value: function (val) {
      this.authors = val
    },
    allChecked: function (val) {
      this.authors.forEach((author) => {
        author.checked = val
      })
      this.authors = Object.assign([], this.authors)
    }
  },
  data () {
    return {
      authors: null,
      allChecked: false
    }
  },
  methods: {
    authorChecked: function (author) {
      let index = this.authors.indexOf(author)

      if (typeof index !== 'undefined') {
        this.authors[index].checked = true
      }
    },
    deleteAllSelected: function () {
      this.authors.forEach((author) => {
        if (author.checked === true) {
          this.context.removeAuthor(author)
        }
      })
    },
    addAllSelected: function () {
      this.authors.forEach((author) => {
        if (author.checked === true) {
          this.context.addAuthor(author, 'author')
        }
      })
    }
  },
  mounted () {
    $(document).on('click', '.filter .dropdown-menu', function (e) {
      e.stopPropagation()
    })
  },
  beforeMount () {
    this.authors = this.value
    this.authors.forEach((author) => {
      author.checked = false
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ListAuthors/ListAuthorsSimilar.vue